module.exports = __webpack_public_path__ + "img/zhaosheng.1833c8ae.jpg";